import script from "./EnrollStudentRegister.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrollStudentRegister.vue?vue&type=script&setup=true&lang=js"

import "./EnrollStudentRegister.vue?vue&type=style&index=0&id=fc18fc2a&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc18fc2a"]])

export default __exports__